import type { ComponentType } from 'react';
import {
  ShieldCheckIcon,
  TrophyIcon,
  CheckBadgeIcon,
  UserIcon,
  UserPlusIcon,
  UserGroupIcon,
  AcademicCapIcon,
  MegaphoneIcon,
  ClipboardDocumentCheckIcon,
  WalletIcon,
  BanknotesIcon,
  KeyIcon,
  WrenchScrewdriverIcon,
  HeartIcon,
  StarIcon,
  FlagIcon,
  SparklesIcon,
  BoltIcon,
  CalendarIcon,
  EnvelopeIcon,
} from '@heroicons/react/24/outline';

export type RoleIconComponent = ComponentType<{ className?: string }>;

// Icon-Katalog: DB-Schlüssel (roles.icon) -> Heroicon
export const ROLE_ICONS: Record<string, { component: RoleIconComponent; label: string }> = {
  'shield-check': { component: ShieldCheckIcon, label: 'Schild' },
  'trophy': { component: TrophyIcon, label: 'Pokal' },
  'check-badge': { component: CheckBadgeIcon, label: 'Prüfsiegel' },
  'user': { component: UserIcon, label: 'Person' },
  'user-plus': { component: UserPlusIcon, label: 'Gast' },
  'user-group': { component: UserGroupIcon, label: 'Gruppe' },
  'academic-cap': { component: AcademicCapIcon, label: 'Ausbildung' },
  'megaphone': { component: MegaphoneIcon, label: 'Megafon' },
  'clipboard-check': { component: ClipboardDocumentCheckIcon, label: 'Checkliste' },
  'wallet': { component: WalletIcon, label: 'Kasse' },
  'banknotes': { component: BanknotesIcon, label: 'Finanzen' },
  'key': { component: KeyIcon, label: 'Schlüssel' },
  'wrench': { component: WrenchScrewdriverIcon, label: 'Technik' },
  'heart': { component: HeartIcon, label: 'Herz' },
  'star': { component: StarIcon, label: 'Stern' },
  'flag': { component: FlagIcon, label: 'Flagge' },
  'sparkles': { component: SparklesIcon, label: 'Funkeln' },
  'bolt': { component: BoltIcon, label: 'Blitz' },
  'calendar': { component: CalendarIcon, label: 'Kalender' },
  'envelope': { component: EnvelopeIcon, label: 'Post' },
};

export const ROLE_ICON_KEYS = Object.keys(ROLE_ICONS);

// Fallback für Rollen ohne gesetztes Icon (bestehende System-Rollen)
const NAME_FALLBACK: Record<string, string> = {
  board: 'shield-check',
  trainer: 'trophy',
  auditor: 'check-badge',
  member: 'user',
  guest: 'user-plus',
};

interface RoleLike {
  name?: string;
  icon?: string | null;
}

// Liefert die Icon-Komponente einer Rolle (DB-Icon, sonst Fallback nach Name)
export const getRoleIconComponent = (role: RoleLike | null | undefined): RoleIconComponent => {
  if (role?.icon && ROLE_ICONS[role.icon]) {
    return ROLE_ICONS[role.icon].component;
  }
  const fallbackKey = role?.name ? NAME_FALLBACK[role.name] : undefined;
  if (fallbackKey && ROLE_ICONS[fallbackKey]) {
    return ROLE_ICONS[fallbackKey].component;
  }
  return UserGroupIcon;
};
